import { cn } from '@/lib/utils'

interface AuroraProps {
    /** Fade the bottom edge back into paper, for sections that sit mid-page. */
    fadeBottom?: boolean
    className?: string
}

/**
 * The brand field: Modulify red, orange, coral and amber blurred into one
 * another. Purely decorative, so it is hidden from assistive technology.
 */
export const Aurora = ({ fadeBottom = false, className }: AuroraProps) => {
    return (
        <div aria-hidden className={cn('aurora', className)}>
            <span className='aurora__blob aurora__blob--orange' />
            <span className='aurora__blob aurora__blob--red' />
            <span className='aurora__blob aurora__blob--coral' />
            <span className='aurora__blob aurora__blob--amber' />
            <span className='aurora__veil' />
            {fadeBottom && <span className='aurora__veil aurora__veil--edge' />}
        </div>
    )
}
